import React from 'react';

const FixedAspectRatio = ({ width, height, children, className = '', style = {} }) => (
    <div style={{ width: '100%', paddingTop: (height / width) * 100 + '%', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, ...style }} className={className}>
            {children ? children : null}
        </div>
    </div>
);

export default FixedAspectRatio;
